// extracted by extract-css-chunks-webpack-plugin
module.exports = {"root":"_2Z3tO","arrow":"_1WWS-","date":"_1fwaC","title":"BxTrb","subTitle":"_2t1iO"};